import { useSelector } from 'react-redux';
import styles from '../styles.module.scss';
import cx from 'classnames';
import { Checkbox } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { replaceTokensInString } from '../../../../utils';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';

const EquipmentInformation = ({ checked, onCheck, widgetId, ...props }) => {
  const [t] = useTranslation();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const imageUrl = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.imageURL
  );
  const model = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.model
  );
  const serialNumber = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.serialNumber
  );
  const equipmentFamily = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.equipmentFamily
  );
  const hasSerialNumber = !!serialNumber;
  const label = (
    <span
      key="equipmentFilterMessage"
      className={cx('my-0 color-dark-gray', styles['equipment-checkbox-label'])}
    >
      {replaceTokensInString(t('REFINE_RESULTS_FOR'), '')}
      <span
        className={cx(
          'fw-bold my-0 color-dark-gray',
          styles['equipment-checkbox-label'],
          styles['equipment-model-label']
        )}
      >
        {model}
      </span>
    </span>
  );
  const filterByEquipmentCheck = widgetId
    ? `filterByEquipmentCheckBox-${widgetId}`
    : 'filterByEquipmentCheckBox';
  const getEquipmentCheckbox = () => (
    <div className="ps-2">
      <Checkbox
        id={filterByEquipmentCheck}
        key="filterByEquipmentCheckBox"
        data-testid="filterCheckbox"
        label={label}
        name="filterForEquipment"
        onChange={e => onCheck(e.target.checked)}
        checked={checked}
        {...props}
      />
    </div>
  );

  return (
    <>
      <div className="d-flex flex-row align-items-start">
        <div
          className={cx(
            styles['equipment_thumbnail-wrapper'],
            'd-md-flex align-items-center d-none'
          )}
        >
          <img
            src={imageUrl}
            alt={`${model} ${serialNumber}`}
            width="64"
            height="33"
          />
        </div>
        <div className="ms-md-2">
          <p className="text-xl mb-0 text-univers--bold u-color--DarkGray">
            {`${model} ${equipmentFamily}`}
          </p>
          {hasSerialNumber ? (
            <p className="text-sm text-univers u-color--DarkGray">
              {`${t('MEQ_SERIAL')} ${serialNumber}`}
            </p>
          ) : (
            isLG && getEquipmentCheckbox()
          )}
        </div>
      </div>
      {hasSerialNumber || !isLG ? getEquipmentCheckbox() : null}
    </>
  );
};

EquipmentInformation.propTypes = {
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  widgetId: PropTypes.number
};

export default EquipmentInformation;
